<template>
  <Breadcrumb />
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <form class="row g-3 form-permission-group-edit" novalidate>
            <div v-if="errors.length > 0" class="alert alert-warning">
              <ul class="mb-0">
                <li v-for="error in errors" v-bind:key="error">
                  {{ error }}
                </li>
              </ul>
            </div>
            <div class="col-md-6">
              <label for="ParentPermissionGroup" class="form-label"
                >{{
                  $t(
                    "PermissionGroups.ParentPermissionGroup",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}
              </label>
              <FormSelect
                type="SelectWithRemoteDataAndInternalSearch"
                :isDetailIconShow="true"
                :routeLink="String.format('#/PermissionGroup/Edit/')"
                @onChange="onChangeParentPermissionGroup"
                :selectedData="selectedParent"
                :isParameters="true"
                :isGatewayRequest="true"
                :requestUrl="
                  String.format(
                    '/Lcdp-SummaryOrganizationalUnitItems?name=PermissionGroup'
                  )
                "
              />
            </div>
            <div class="col-md-6">
              <label for="ActiveMenu" class="form-label"
                >{{
                  $t(
                    "PermissionGroups.ActiveMenu",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}
              </label>
              <FormSelect
                type="SelectWithRemoteDataAndInternalSearch"
                @onChange="onChangeActiveMenu"
                :isDetailIconShow="true"
                :routeLink="String.format('#/Menu/ListItem/')"
                :selectedData="selectedMenu"
                :isGatewayRequest="true"
                requestUrl="/Lcdp-SummaryMenus"
              />
            </div>
            <div class="col-md-6">
              <label for="Name" class="form-label required"
                >{{
                  $t(
                    "PermissionGroups.Name",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}
              </label>
              <input
                type="text"
                class="form-control"
                id="Name"
                v-model="permissionGroupData.name"
                :autocomplete="this.$isAutoComplete"
                :spellcheck="this.$isTextSpellCheck"
                required
              />
            </div>
            <div class="col-md-6">
              <label for="SpecificCode1" class="form-label"
                >{{
                  $t(
                    "PermissionGroups.SpecificCode1",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}
              </label>
              <input
                type="text"
                class="form-control"
                id="SpecificCode1"
                v-model="permissionGroupData.specificCode1"
                :spellcheck="this.$isTextSpellCheck"
                :autocomplete="this.$isAutoComplete"
              />
            </div>
            <div class="col-md-6">
              <label for="Description" class="form-label"
                >{{
                  $t(
                    "PermissionGroups.Description",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}
              </label>
              <textarea
                type="text"
                class="form-control"
                id="Description"
                rows="1"
                v-model="permissionGroupData.description"
                :spellcheck="this.$isTextSpellCheck"
              ></textarea>
            </div>
            <div class="col-md-6">
              <label for="SpecificCode2" class="form-label"
                >{{
                  $t(
                    "PermissionGroups.SpecificCode2",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}
              </label>
              <input
                type="text"
                class="form-control"
                id="SpecificCode2"
                v-model="permissionGroupData.specificCode2"
                :spellcheck="this.$isTextSpellCheck"
                :autocomplete="this.$isAutoComplete"
              />
            </div>
            <div class="col-md-6">
              <label for="AdminPublicIds" class="form-label"
                >{{
                  $t(
                    "PermissionGroups.GroupAdmin",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}
              </label>
              <FormSelect
                type="SelectWithRemoteDataAndInternalSearch"
                @onMultipleSelectChange="onChangeGroupAdmin"
                :selectedData="selectedAdmins"
                :isMultiple="true"
                :isParameters="true"
                :isGatewayRequest="true"
                :requestUrl="
                  String.format(
                    '/Lcdp-SummaryOrganizationalUnitItems?name=User'
                  )
                "
              />
            </div>
            <div class="col-md-6">
              <label for="SpecificCode3" class="form-label"
                >{{
                  $t(
                    "PermissionGroups.SpecificCode3",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}
              </label>
              <input
                type="text"
                class="form-control"
                id="SpecificCode3"
                v-model="permissionGroupData.specificCode3"
                :autocomplete="this.$isAutoComplete"
                :spellcheck="this.$isTextSpellCheck"
              />
            </div>
            <div class="col-md-6">
              <label for="WelcomeUrl" class="form-label"
                >{{
                  $t(
                    "PermissionGroups.WelcomeUrl",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}
              </label>
              <input
                type="text"
                class="form-control"
                id="WelcomeUrl"
                v-model="permissionGroupData.welcomeUrl"
                :autocomplete="this.$isAutoComplete"
                :spellcheck="this.$isTextSpellCheck"
              />
            </div>
            <div class="col-12">
              <div class="form-check">
                <label for="IsActive" class="form-label">{{
                  $t(
                    "BaseModelFields.IsActive",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}</label>
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="IsActive"
                  v-model="permissionGroupData.isActive"
                />
              </div>
            </div>
            <ActionButtons
              @methodSave="onSubmit('btn-save')"
              :isNewRecord="false"
            />
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  name: "PermissionGroupEdit",
  components: {},
  data() {
    return {
      submitButtonHtml: String.format(
        '<span class="loading-block"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span> {0}</span></span>',
        this.$t(
          "Buttons.PleaseWait",
          {},
          { locale: this.$store.state.activeLang }
        )
      ),
      disabledButtonClasses: ".btn-save",
      errors: [],
      selectedParent: [],
      selectedMenu: [],
      selectedAdmins: [],
      permissionGroupData: {},
    };
  },
  methods: {
    onChangeParentPermissionGroup(selected) {
      this.permissionGroupData.parentPermissionGroupPublicId = selected.key;
      this.permissionGroupData.parentPermissionGroupName = selected.value;
    },
    onChangeActiveMenu(selected) {
      this.permissionGroupData.activeMenuPublicId = selected.key;
      this.permissionGroupData.activeMenuName = selected.key;
    },
    onChangeGroupAdmin(ids) {
      this.permissionGroupData.adminPublicIds = ids;
    },
    getPermissionGroup() {
      this.$prodGatewayAxios
        .get(
          String.format(
            "/Lcdp-GetPermissionGroup?id={0}",
            this.$route.params.permissionGroupId
          )
        )
        .then((response) => {
          this.permissionGroupData = response.data;

          if (
            !String.isNullOrWhiteSpace(
              response.data.parentPermissionGroupPublicId
            ) &&
            !String.isNullOrWhiteSpace(response.data.parentPermissionGroupName)
          ) {
            this.selectedParent.push({
              key: response.data.parentPermissionGroupPublicId,
              value: response.data.parentPermissionGroupName,
            });
          }

          if (
            !String.isNullOrWhiteSpace(response.data.activeMenuPublicId) &&
            !String.isNullOrWhiteSpace(response.data.activeMenuName)
          ) {
            this.selectedMenu.push({
              key: response.data.activeMenuPublicId,
              value: response.data.activeMenuName,
            });
          }

          if (
            !String.isNullOrWhiteSpace(response.data.adminPublicIds) &&
            !String.isNullOrWhiteSpace(response.data.adminNames)
          ) {
            var listAdminIds = response.data.adminPublicIds;
            var listNames = response.data.adminNames;
            var self = this;
            if (
              listAdminIds.includes(this.$systemSeparator) &&
              listNames.includes(this.$systemSeparator)
            ) {
              listAdminIds = listAdminIds.split(this.$systemSeparator);
              listNames = listNames.split(this.$systemSeparator);
              $.each(listAdminIds, function (i, v) {
                if (v !== "" && listNames !== "") {
                  self.selectedAdmins.push({
                    key: v,
                    value: listNames[i],
                  });
                }
              });
            } else {
              self.selectedAdmins.push({
                key: listAdminIds,
                value: listNames,
              });
            }
          }
        })
        .catch(function (error) {
          //alert(error);
        });
    },
    onSubmit(buttonName) {
      var form = $(".form-permission-group-edit");
      form.addClass("was-validated");
      if (!form[0].checkValidity()) {
        return;
      }

      var button = $(String.format(".{0}", buttonName)),
        firstSpan = button.find("span:first"),
        loadingBlock = button.find(".loading-block"),
        disabledButtons = $(this.disabledButtonClasses);

      disabledButtons.prop("disabled", true);
      firstSpan.hide();
      if (loadingBlock.length === 0) {
        firstSpan.after(this.submitButtonHtml);
        loadingBlock = button.find(".loading-block");
      } else {
        loadingBlock.show();
      }

      this.errors = [];
      this.$prodGatewayAxios
        .post("/Lcdp-UpdatePermissionGroup", {
          ...this.permissionGroupData,
        })
        .then((r) => {
          var response = r.data;
          if (response.isOk) {
            this.$router.push("/PermissionGroup/List");
          } else {
            firstSpan.show();
            loadingBlock.hide();
            disabledButtons.prop("disabled", false);
            this.errors.push(response.msg);
          }
        })
        .catch((r) => {
          firstSpan.show();
          loadingBlock.hide();
          disabledButtons.prop("disabled", false);
          this.errors.push(r);
        });
    },
  },
  mounted() {
    this.getPermissionGroup();
  },
};
</script>
